<template>
  <!-- 常见问题页面 -->
  <div class="box1">
    <!-- 搜索 -->
    <div class="search-box">
      <div class="search">
        <search :val="val" @handelScreen="handelScreen"></search>
      </div>
    </div>
    <div class="keyword">
      <p class="title-Individual-center">
        <span class="firm-clickable" v-if="CurrentPage == '/knowledge'" @click="handelReturn"
          >知识区</span
        ><span class="firm-clickable" v-else @click="handelReturn">常见问题</span>
        <i class="el-icon-arrow-right"></i>
        <span class="span-Individual-center">{{ val }}</span>
      </p>
    </div>

    <!-- 主体 -->
    <div class="main-body">
      <!-- 全部问题主体 -->
      <div class="All-body" v-if="allProblem.length != 0">
        <div0
          class="Issue-details firm-clickable"
          v-for="(item, index) in allProblem"
          :key="index"
          @click="handelDetails(item)"
        >
          <div class="con-box">
            <div class="Issue-details-title">
              <p v-html="item.name"></p>
              <p>阅读量：{{ item.readCount }}</p>
            </div>
            <p class="Issue-details-con">{{ item.contentText }}</p>
          </div>
        </div0>
      </div>
      <div class="All-body" v-else>
        <div class="NoData-Available">
          <div class="NoData-img"></div>
          <p class="NoData-p">暂无数据</p>
        </div>
      </div>
    </div>
    <!-- 分页 -->
    <div class="paging">
      <paging
        :pagingObj="pagingObj"
        @handleCurrentChange="handleCurrentChange"
      ></paging>
    </div>
  </div>
</template>

<script>
import {
  postListCommonProblem, // 问题列表
  postListKnowledgeArticle, // 知识列表
} from "../../../assets/api/indexl";
// 引入分页组件
import paging from "../../../components/paging.vue";
// 引入搜索组件
import search from "../../../components/search.vue";
export default {
  components: { paging, search },

  data() {
    return {
      Tips: "搜索内容", // 传给搜索组件的数据
      input: "", // 搜索
      allProblem: [],
      pagingObj: {
        currentPage: 1, //当前页
        pageSize: 10, // 一页显示多少个
        totalDevice: 100, //用户总数
      }, // 分页数据
      val: "", // 搜索内容
      CurrentPage: "", // 那个页面过来的，常见问题区/知识区
    };
  },
  created() {
    // 搜索框的值
    this.val = this.$route.query.category;
    // 区分知识区/常见问题
    console.log(this.$route.query.CurrentPage);
    this.CurrentPage = this.$route.query.CurrentPage;
    // /problem 调用常见问题区的数据接口
    if (this.CurrentPage == "/problem") {
      this.postListCommonProblem();
    } else {
      // 调用知识区接口
      this.postListKnowledgeArticle();
    }
  },
  mounted() {},
  destroyed() {},
  methods: {
    // 返回常见问题页面
    handelReturn() {
      if (this.CurrentPage == "/problem") {
        //跳转常见问题
        this.$router.push({
          path: "/problem",
        });
      } else {
        this.$router.push({
          path: "/knowledge",
        });
      }
    },
    // 常见问题 - 下方问题  全部问题列表 接口
    async postListCommonProblem() {
      var data = {
        data: {
          id: this.$store.getters.getUser.id,
          contentText: this.val,
        },
      };
      const res = await postListCommonProblem(
        data,
        this.pagingObj.currentPage, // 当前页
        this.pagingObj.pageSize
      );
      if (res.code == 0) {
        // 赋值
        this.allProblem = res.data.list;
        // 变色 关键字
        for (var i in this.allProblem) {
          var reg = new RegExp(this.val, "g");
          this.allProblem[i].name = this.allProblem[i].name.replace(
            reg,
            "<span style='color:#fc7926'>" + this.val + "</span>"
          );
        }
        // 赋值 总数
        this.pagingObj.totalDevice = res.data.total;
      } else {
        // 接口调用失败
        // this.$tool.PromptBox("error", res.msg);
      }
    },
    // 知识区 - 下方问题  全部问题列表 接口
    async postListKnowledgeArticle() {
      var data = {
        data: {
          id: this.$store.getters.getUser.id,
          contentText: this.val,
        },
      };
      const res = await postListKnowledgeArticle(
        data,
        this.pagingObj.currentPage, // 当前页
        this.pagingObj.pageSize
      );
      if (res.code == 0) {
        // 赋值
        this.allProblem = res.data.list;
        // 变色 关键字
        for (var i in this.allProblem) {
          var reg = new RegExp(this.val, "g");
          this.allProblem[i].name = this.allProblem[i].name.replace(
            reg,
            "<span style='color:#fc7926'>" + this.val + "</span>"
          );
        }
        // 赋值 总数
        this.pagingObj.totalDevice = res.data.total;
      } else {
        // 接口调用失败
        // this.$tool.PromptBox("error", res.msg);
      }
    },
    // 搜索
    handelScreen(val) {
      this.val = val;
      // /problem 调用常见问题区的数据接口
      if (this.CurrentPage == "/problem") {
        this.postListCommonProblem();
      } else {
        // 调用知识区接口
        this.postListKnowledgeArticle();
      }
    },
    // 跳转 问题详情页
    handelDetails(item) {
      // 打开新窗口 跳转新页面  跳转搜索详情
      let routeData = this.$router.resolve({
        path: "/IssueDetails",
        query: { category: item.id, CurrentPage: this.CurrentPage },
      });
      if (item.id != "") {
        window.open(routeData.href, "_blank");
      }
      // window.open("/#/IssueDetails", "_blank"); //关键在此
    },
    // 分页
    handleCurrentChange(num) {
      this.pagingObj.currentPage = num;
      // /problem 调用常见问题区的数据接口
      if (this.CurrentPage == "/problem") {
        this.postListCommonProblem();
      } else {
        // 调用知识区接口
        this.postListKnowledgeArticle();
      }
    },
  },
};
</script>

<style scoped lang="less">
.box1 {
  width: 100%;
  height: 100%;
}
// 搜索
.search-box {
  min-width: 1200px;
  height: 54px;
  margin: auto;
  margin-bottom: 50px;
  margin-top: 33px;
  display: flex;
  .search {
    width: 720px;
    height: 54px;
    line-height: 54px;
    margin: auto;
    display: flex;
    position: relative;
  }
}
// 搜索关键字
.keyword {
  width: 1184px;
  margin: 0 auto;
  margin-bottom: 20px;
}
//主体
.main-body {
  width: 1184px;
  min-height: 600px;
  margin: auto;
  display: flex;
  flex-direction: column;
}
// 全部问题
.All-body {
  width: 100%;
  min-height: 200px;
  font-family: PingFangSC-Medium;
  font-size: 14px;
  color: #666666;
  font-weight: 400;
  .NoData-Available {
    width: 120px;
    height: 150px;
    margin: auto;

    .NoData-img {
      width: 120px;
      height: 120px;
      background-image: url("../../../assets/imgs/zanwushuju@3x.svg");
      background-size: 100% 100%;
    }
    .NoData-p {
      width: 100%;
      font-size: 12px;
      color: #999999;
      text-align: center;
      margin-top: 15px;
    }
  }
  .Issue-details:hover {
    box-shadow: 0px 0px 10px 0px rgba(50, 145, 248, 0.8);
  }
  .Issue-details {
    width: 100%;
    height: 80px;
    background: #ffffff;
    box-shadow: 0px 0px 10px 0px rgba(125, 125, 125, 0.5);
    border-radius: 20px;
    margin-bottom: 20px;
    display: flex;
    .con-box {
      width: 100%;
      // height: 48px;
      margin: auto 0;
      margin-left: 20px;
      margin-right: 20px;
// border: 1px solid gold;
      .Issue-details-title {
        // height: 21px;
        line-height: 21px;
        width: 100%;
        display: flex;
        justify-content: flex-end;
        p:nth-child(1) {
          // flex: 1;
          width: 1070px;
          font-size: 18px;
          color: #333333;
          white-space: nowrap; //不换行
          overflow: hidden; //超出部分隐藏
          text-overflow: ellipsis; //文本溢出显示省略号
          font-weight: 600;
        }
        p:nth-child(2) {
          margin-left: 20px;
          margin-right: 40px;
          width: 130px;
        }
      }
      .Issue-details-con {
        // height: 18px;
        width: 1100px;
        margin-top: 10px;
        white-space: nowrap; //不换行
        overflow: hidden; //超出部分隐藏
        text-overflow: ellipsis; //文本溢出显示省略号
      }
    }
  }
}
// 分页
.paging {
  width: 1200px;
  height: 30px;
  margin: auto;
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}
</style>
